package dev.valvassori.minesweeper.model

enum class GameState(val emoji: String) {
    ALIVE("🙂"),
    DEAD("🤯"),
    VICTORY("😎"),
}
